import React, { useEffect, useState } from "react";
import ConfirmationPage from "./components/ConfirmationPage";

import RegisterStep from "./components/RegisterStep";

import { USER_ROLES } from "../../../utils/UIProvider";

import { useNavigate } from "react-router-dom";
import OtpStep from "./components/otp.screen";

export default function StudentRegistration() {
  const [currentStep, setCurrentStep] = useState<number>(1);
  const navigate = useNavigate();
  const [data, setData] = useState<any>({});

  return (
    <>
      {currentStep === 1 && (
        <RegisterStep
          value={{
            data,
            role: USER_ROLES.STUDENT,
          }}
          onBack={() => navigate("/")}
          onNext={(data: any) => {
            setData((prev: any) => {
              return {
                ...prev,
                ...data,
                user: {
                  ...data.user,
                  email: prev?.email,
                },
              };
            });
            setCurrentStep(2);
          }}
        />
      )}

      {currentStep === 2 && (
        <ConfirmationPage
          eventName="SIGNUP_STUDENTS_REGISTRATION_CONFIRMATION_INDEX"
          value={{
            eventName:
              "SIGNUP_STUDENTS_REGISTRATION_CONFIRMATION_BUTTON_PLAYNOW",
            ...data,
          }}
          onBack={() => setCurrentStep(1)}
          onNext={() => {
            window.location.href = "https://portal.heroicgameday.in/login";
          }}
        />
      )}
    </>
  );
}
